import { Link } from "react-router-dom";

const images = {
  districtMap: "/assets/hardcastle/district-6-map.png",
  districtMapWide: "/assets/hardcastle/district-6-map-wide.png",
};

const earlyVotingDates = [
  "Monday, April 20, 2026",
  "Closed Tuesday, April 21, 2026",
  "Wednesday, April 22, 2026",
  "Thursday, April 23, 2026",
  "Friday, April 24, 2026",
  "Saturday, April 25, 2026",
  "Sunday, April 26, 2026",
  "Monday, April 27, 2026",
  "Tuesday, April 28, 2026",
];

function ElectionInformationPage() {
  return (
    <main className="bg-white px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto max-w-3xl text-center">
          <p className="font-bold uppercase tracking-[0.2em] text-[#c0352b]">Election information</p>
          <h1 className="mt-3 text-5xl font-bold text-[#08213d]" style={{ fontFamily: "Libre Baskerville, serif" }}>
            Vote for Jason Hardcastle in District 6.
          </h1>
          <p className="mt-5 text-lg leading-8 text-[#37516a]">
            Always verify your district, precinct, dates, and voting location through Galveston Votes before making your plan.
          </p>
        </div>

        <section className="mt-12 grid gap-6 lg:grid-cols-2">
          <div className="rounded-[2rem] bg-[#08213d] p-8 text-white shadow-xl">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#f7d77a]">Election Day</p>
            <h2 className="mt-3 text-4xl font-black">Saturday, May 2, 2026</h2>
            <p className="mt-5 text-white/75">Make a plan, bring a friend, and confirm your polling place before heading out.</p>
          </div>

          <div className="rounded-[2rem] bg-[#f7f1e6] p-8 shadow-xl">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#c0352b]">Early voting</p>
            <h2 className="mt-3 text-3xl font-black text-[#08213d]">Starts Monday, April 20, 2026</h2>
            <ul className="mt-5 grid gap-3 text-[#37516a] sm:grid-cols-2">
              {earlyVotingDates.map((date) => (
                <li key={date} className="rounded-xl bg-white px-4 py-3 font-semibold shadow-sm">
                  {date}
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="mt-12 grid gap-8 rounded-[2rem] bg-[#f7f1e6] p-8 shadow-xl lg:grid-cols-2 lg:items-center">
          <div>
            <p className="font-bold uppercase tracking-[0.2em] text-[#c0352b]">Am I in District 6?</p>
            <h2 className="mt-3 text-4xl font-bold text-[#08213d]" style={{ fontFamily: "Libre Baskerville, serif" }}>
              District 6 stretches from Harve Lafitte to the West End.
            </h2>
            <p className="mt-5 text-lg leading-8 text-[#37516a]">
              These campaign maps are included for convenience. For the official district and precinct lookup, visit GalvestonVotes.org.
            </p>
            <div className="mt-8 flex flex-col gap-4 sm:flex-row">
              <a href="http://galvestonvotes.org" target="_blank" rel="noopener noreferrer" className="rounded-full bg-[#0b2f58] px-7 py-3 text-center text-sm font-extrabold uppercase tracking-[0.16em] text-white transition hover:bg-[#143f70]">
                Galveston Votes
              </a>
              <Link to="/contact" className="rounded-full border-2 border-[#0b2f58] px-7 py-3 text-center text-sm font-extrabold uppercase tracking-[0.16em] text-[#0b2f58] transition hover:bg-white">
                Ask the campaign
              </Link>
            </div>
          </div>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-1">
            <img src={images.districtMap} alt="District 6 detail map" className="rounded-2xl bg-white object-cover shadow-lg" />
            <img src={images.districtMapWide} alt="District 6 Galveston map" className="rounded-2xl bg-white object-cover shadow-lg" />
          </div>
        </section>
      </div>
    </main>
  );
}

export default ElectionInformationPage;
